<template>
  <p class="action-button">
    <vs-button
      v-if="view != null"
      radius
      v-tooltip="'Detalhes'"
      color="dark"
      type="gradient"
      icon-pack="feather"
      icon="icon-search"
      class="d-inline"
      @click="viewClick()"
    ></vs-button>

    <vs-button
      v-if="edit != null && $can($actionsDefault.Escrita, subjectPermission)"
      radius
      v-tooltip="'Editar'"
      color="success"
      type="gradient"
      icon-pack="feather"
      icon="icon-edit"
      class="d-inline"
      @click="editClick()"
    ></vs-button>
  </p>
</template>

<script>
export default {
  props: {
    view: {
      type: String,
    },
    edit: {
      type: String,
    },
    subjectPermission: {
      type: String,
      default: "",
    },
  },
  methods: {
    viewClick() {
      this.$emit("viewClick");
    },
    editClick() {
      this.$emit("editClick");
    },
  },
};
</script>

<style lang="scss">
.action-button {
  display: flex;
  button {
    margin-right: 5px;
  }
}
</style>
